import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { chargeSeller } from '../../store/actions/picker.action';
import LoaderSpinner from '../common/Loader';
import InputCalculator from '../common/InputCalculator';
import DatePickerComponent from '../common/DatePickerComponent';
import { useNavigate } from 'react-router-dom';

/* istanbul ignore next */
const ChargeSeller = ({ show, handleCancel, taskId, fetchTaskDetails }) => {
    const navigate = useNavigate();
    const [amount, setAmount] = useState('');
    const [errorAmount, setErrorAmount] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [comment, setComment] = useState('');
    const [transactionDate, setTransactionDate] = useState(new Date());
    const [sendEmail, setSendEmail] = useState(true);
    const [markedAsClosed, setMarkedAsClosed] = useState(true);

    // Validate amount input
    const validateAmount = (value) => {
        if (!value || isNaN(value) || Number(value) <= 0) { // NOSONAR
            return 'Please enter a valid amount';
        }
        return '';
    };

    // Handle amount input change with decimal validation
    const handleAmountChange = (e) => {
        const val = e.target.value;

        // Allow empty, numbers, decimal points, and basic math operators
        if (val === "" || /^[\d+\-*/.() ]+$/.test(val)) {
            setAmount(val);
            setErrorAmount("");
        } else {
            setErrorAmount("Invalid characters");
        }
    };

    // Handle input blur for final validation
    const handleBlur = (e) => {
        let { value } = e.target;
        const error = validateAmount(value);
        if (!error) {
            setAmount(value);
        }

        setErrorAmount(error);
    };

    // Handle Charge Seller button click
    const handleChargeSeller = async () => {
        const error = validateAmount(amount);
        if (error) {
            setErrorAmount(error);
            return;
        }

        setShowLoader(true);

        const payload = {
            taskId: Number(taskId),
            debitAmount: amount,
            sendEmail: sendEmail,
            debitComment: comment,
            transactionDate: transactionDate.toISOString(),
            isStatusClosed: markedAsClosed
        };

        try {
            const response = await chargeSeller(payload);
            if (response?.data?.Status === 200) {
                toast.success('Task charged successfully');
                if (markedAsClosed) {
                    navigate('/tasks');
                }
                fetchTaskDetails();
                handleCancel();
            } else {
                toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to charge task');
            }
        } catch (err) {
            toast.error('An error occurred');
        } finally {
            setShowLoader(false);
        }
    };

    return (
        <Modal show={show} centered backdrop="static" className="modalDeleteWrapper" size="lg" onHide={handleCancel}>
            <Modal.Header closeButton>
                <div className="modal-main-div">
                    <span className="modal-m-text pr-3">Post Charges</span>
                    {showLoader && <LoaderSpinner />}
                </div>
            </Modal.Header>

            <Modal.Body>
                <Row className="flexCenter pt-4 fontFix">
                    <Col sm={12} lg={12} className="formLabel mb-1">
                        Enter Amount ($) <span className="require-field">*</span>
                    </Col>
                    <Col sm={12} lg={12}>
                        <InputCalculator
                            value={amount}
                            onChange={handleAmountChange}
                            onBlur={handleBlur}
                            placeholder="Enter Amount"
                            maxLength={20}
                        />
                    </Col>
                    <Col lg={12}>
                        {errorAmount && <div className="error fontFix">{errorAmount}</div>}
                    </Col>

                    <Col sm={12} lg={12} className="formLabel mt-3">Date</Col>
                    <Col sm={12} lg={12} className='postDateWrapper'>
                        <DatePickerComponent
                            showFutureDate={false}
                            dateField={transactionDate}
                            fieldName={'transactionDate'}
                            handleDateChange={(date) => setTransactionDate(date)}
                        />
                    </Col>

                    <Col lg={12} className="formLabel mt-3 mb-1">
                        Comment
                    </Col>
                    <Col sm={12} lg={12}>
                        <textarea
                            className="form-control"
                            placeholder="Enter comment"
                            rows={3}
                            maxLength={170}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            onBlur={(e) => setComment(e.target.value.trim())}
                        ></textarea>
                        <div className='mt-2'>
                            <input
                                className="sendNotification mr-1"
                                type="checkbox"
                                checked={sendEmail}
                                onChange={(e) => setSendEmail(e.target.checked)}
                            />
                            {" "}
                            Send Notification Email
                        </div>
                        <div className='mt-2'>
                            <input
                                className="sendNotification mr-1"
                                type="checkbox"
                                checked={markedAsClosed}
                                onChange={(e) => setMarkedAsClosed(e.target.checked)} 
                            /> Marked as Closed
                        </div>
                    </Col>
                </Row>
            </Modal.Body>

            <Row className="modaL_footer mt-1 mr-2">
                <Col className="csv_Buttons">
                    <button
                        className="btn cus-seconday-bg-btn uploadBtn"
                        disabled={showLoader || !!errorAmount || !amount}
                        onClick={handleChargeSeller}
                    >
                        Charge
                    </button>
                    <button
                        className="btn cus-seconday-bg-btn marginLeft5 cancelBtn"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                </Col>
            </Row>
        </Modal>
    );
};
ChargeSeller.propTypes = {
    show: PropTypes.bool,
    handleCancel: PropTypes.func,
    taskId: PropTypes.object,
    fetchTaskDetails: PropTypes.func
};

export default ChargeSeller;